/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.core.model.notification

data class ScheduledNotification(
    val id: Int,
    val type: NotificationType,
    val title: String,
    val body: String,
    val triggerAtMillis: Long,
    val data: Map<String, String> = emptyMap(),
)
